import { render, staticRenderFns } from "./leaveOffice.vue?vue&type=template&id=74230b07&"
import script from "./leaveOffice.vue?vue&type=script&lang=js&"
export * from "./leaveOffice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports